<template>
  <div class="content-01">
    <div class="box" v-for="item in list" :key="item.key" @click="() => goDetail(item.title)">
      <div class="img-box">
        <img :src="item.img" />
      </div>
      <div>{{ item.title }}</div>
      <p style="text-align: center">
        <span style="padding: 0 5px" @click.stop="item.desc.name === '日本签证预约服务' || item.desc.name === '日本签证'
              ? pushRouter(item.desc.url)
              : pushRouter(item.desc.url)">{{ item.desc.name }}</span>
        <!-- open(item.desc.url) -->
        <span v-show="item.desc1 && item.desc1.name" style="padding: 0 5px" @click.stop="
        item.desc1.name === '领事认证' ? open(item.desc1.url) : pushRouter(item.desc1.url)">{{ item.desc1.name }}
        </span>

      </p>
    </div>
  </div>
</template>

<script>
const list = [
  {
    title: "同声传译",
    img: require("../../../assets/images/icon_function_interpretation.png"),
    desc: {
      name: "口译服务",
      url: `/htmlContent?type=contentNews&contentCode=RESF27EF67D23ECEAC&name=口译服务&linkname=翻译服务/口译服务/详情`,
    },
    desc1: {
      name: "同传设备",
      url: `/htmlContent?type=contentNews&contentCode=RESDF11AAACE6BCD79&name=同传设备&linkname=国际会议/同传设备/详情`,
    },
    key: "1",
  },
  {
    title: "窗口服务",
    img: require("../../../assets/images/icon_function_window service.png"),
    desc: { name: "办事指南", url: "/office-service" },
    desc1: { name: "窗口业务", url: "/window-service" },
    key: "4",
  },
  {
    title: "签证预约",
    img: require("../../../assets/images/icon_function_online_work.png"),
    desc: {
      name: "日本签证预约服务",
      url: "/specialServiceInformation?linkname=我要预约",
    },
    desc1: {},
    key: "2",
  },
  {
    title: "查询服务",
    img: require("../../../assets/images/icon_top_search.png"),
    desc: { name: "日本签证", url: "/query?linkname=我要查询" },
    desc1: {
      name: "领事认证",
      url: "https://consular.mfa.gov.cn/VERIFY/#/hcRzYyAdSgcx",
    },
    key: "3",
  },
];
export default {
  name: "sider-content-01",
  data () {
    return {
      list,
    };
  },
  methods: {
    goDetail (val) {
      const routerMap = {
        窗口服务: "/business-lobby",
        同声传译: "/some-inter",
        查询服务: "/search-service",
      };
      this.pushRouter(routerMap[val]);
    },
    open (url) {
      window.open(url);
    },
    doJump (item) {
      this.pushRouter(item.desc.url)
      return
      if (item.desc.name === '日本签证预约服务' || item.desc.name === '日本签证') {
        open(item.desc.url)
      } else {
        this.pushRouter(item.desc.url)
      }
    }
  },
};
</script>

<style scoped lang='less'>
.content-01 {
  padding: 80px 0 40px 0;
}
.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}
.box {
  width: 250px;
  height: 260px;
  border: 1px solid #e5e5e5;
  display: inline-block;
  cursor: pointer;
  .img-box {
    display: inline-block;
    width: 68px;
    height: 68px;
    margin-top: 46px;
    text-align: center;
    border-radius: 50%;
    img {
      width: 40px;
      height: 40px;
      margin-top: 13px;
    }
  }

  &:first-of-type .img-box {
    background: #846dfb;
  }

  &:nth-of-type(3) .img-box {
    background: rgba(189, 26, 45, 1);
  }

  &:nth-of-type(4) .img-box {
    background: rgba(139, 102, 84, 1);
  }

  &:nth-of-type(2) .img-box {
    background: rgba(252, 113, 63, 1);
  }

  div {
    width: 100%;
    //height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 30px;
    margin-top: 18px;
  }

  p {
    margin-top: 17px;
  }

  span {
    width: 152px;
    height: 15px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7f7f7f;
    line-height: 36px;
    &:hover {
      color: #decba4;
    }
  }
}
.box:not(:last-of-type) {
  margin-right: 47px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeIndex/siderContent01.vue